import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface GetShipmentModifiedByDetailsRequestParams {
  modifiedByType: 0 | 1; // User Name, Email Id
}

export const getShipmentModifiedByDetailsAPI = (params: GetShipmentModifiedByDetailsRequestParams) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentModifiedByDetails`,
    method: 'get',
    params,
  });
};

export type ShipmentModifiedByDetailsResponse = {
  modifiedBy: number;
  modifiedByFullDesc: string;
}[];

export const fetchShipmentModifiedByDetails = async (
  params: GetShipmentModifiedByDetailsRequestParams,
): Promise<ShipmentModifiedByDetailsResponse> => {
  const response: AxiosResponse<ShipmentModifiedByDetailsResponse> = await getShipmentModifiedByDetailsAPI(params);
  return response.data;
};
